<template>
    <div class="container" v-touch-swipe.noMouse.left.right="userHasSwiped" :style="container_style">
        <v-zoomer class="player" :style="player_style" pivot='cursor' :limitTranslation="false">
            <div class="player" :style="player_style">
                <img :src="getSlide" class="slide" :style="slide_style" style="object-fit: contain;" />
            </div>
        </v-zoomer>
        <div class="controller bg-secondary" :style="controller_style">
            <q-btn color='white' size="lg"  flat @click="goLeft()" icon="fal fa-chevron-left" :disable="disableButtonPrevious" />
            <q-btn color='white' size="lg"  flat @click="goRight()" icon="fal fa-chevron-right" :disable="disableButtonNext" />
            <q-btn color='white' size="lg" flat @click="fullScreen()" class="fullscreen" icon="fal fa-compress" />
        </div>
    </div>
</template>

<script>
import { AppFullscreen } from 'quasar'
import { mapGetters } from 'vuex'
export default {
    props: ['closing', 'activity', 'display'],

    data() {
        return {
            id_course: '',
            id_trail: '',
            slides: [],
            slide: {},
            current_slide: 1,
            loading: false,
            is_full_screen: false,
            container_style:'',
            player_style: '',
            slide_style: '',
            controller_style: ''
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getSlide() {
            return this.slide ? this.slide.image : ''
        },

        disableButtonPrevious() {
            if (this.loading) return true
            return this.current_slide === 1 ? true : false
        },

        disableButtonNext() {
            if (this.loading) return true
            return this.current_slide == this.slides.length ? true : false
        }
    },

    methods: {
        getSlides() {
            this.slides = this.activity.resource.map(e => ({ ...e, image: e.file }))
            this.current_slide = this.activity.current_slide === 0 ? 1 : this.activity.current_slide
            this.slide = this.slides[this.current_slide - 1]
            this.sendPosition()
        },

        sendPosition() {
            this.loading = true
            let fd = new FormData()
            fd.append('current_slide', this.current_slide)
            fd.append('total_slides', this.slides.length)
            fd.append('id_group_training_module', this.activity.type_id)

            let url = ''
            if (this.id_trail == "") {
                url = `/etraining_courses/group_training/${this.id_course}/set_group_training_module_user_progress/`
            }
            else {
                url = `/etraining_trails/trail/${this.id_trail}/group_training/${this.id_course}/set_group_training_module_user_progress/`
            }

            this.$axios.post(url, fd, this.getHeader)
            .then(response => {
                this.loading = false
            })
            .catch(e => {
                console.log(e)
            })
        },

        userHasSwiped(obj){
            if(obj.direction === 'left') this.goRight()
            else if(obj.direction === 'right') this.goLeft()
        },

        goLeft() {
            if(this.current_slide > 0){
                this.current_slide = this.current_slide - 1
                this.slide = this.slides[this.current_slide - 1]
                this.sendPosition()
            }
        },

        goRight() {
            if(this.current_slide < this.slides.length){
                this.current_slide = this.current_slide + 1
                this.slide = this.slides[this.current_slide - 1]
                this.sendPosition()
            }
        },

        fullScreen(origin) {
            // if (!this.$q.platform.is.cordova) {
                if (!this.is_full_screen) {
                    this.enterFullScreen()
                    if(!this.$q.platform.is.safari) {
                        this.$q.fullscreen.request()
                    }
                }
                else {
                    this.exitFullScreen()
                    if(!this.$q.platform.is.safari) {
                        this.$q.fullscreen.exit()
                    }
                }
            // }
            // else {
            //     let options = {
            //         share: false,
            //         closeButton: false,
            //         copyToReference: false,
            //         headers: '',
            //         piccasoOptions: { }
            //     }

            //     PhotoViewer.show(this.getSlide, '', options)
            // }
        },

        enterFullScreen() {
            this.is_full_screen = true
            this.$emit('display', 'none')
            this.container_style = 'display:block; z-index: 9999; position:fixed; top:0; height:auto; left:0; bottom:0; right:0; overflow:auto;'
            if(this.$q.platform.is.mobile) {
                this.controller_style = 'position:absolute; width:100%; height:9vh; padding:0px;'
                this.player_style = 'width:auto; display:flex; height:91vh; justify-content:center;'
                    this.slide_style = 'width:auto; height:91vh;'
            }
            else {
                this.controller_style = 'position:absolute; width:100%; height:5vh; padding:0px;'
                this.player_style = 'width:auto; display:flex; justify-content:center;'
                this.slide_style = 'width:auto; height:95vh;'
            }
        },

        exitFullScreen() {
            this.is_full_screen = false
            this.$emit('display', 'flex')
            this.container_style = ''
            this.player_style = ''
            this.slide_style = ''
            this.controller_style = ''
        }
    },

    watch: {
        closing: function(val) {
            if (val == true) {
                this.$emit('positionSent')
            }
        },
    },

    created() {
        if( this.$route.params.id_trail) this.id_trail = this.$route.params.id_trail
        if( this.$route.params.id) this.id_course = this.$route.params.id
        this.getSlides()

        if (this.$q.platform.is.mobile) {
            if(!this.$q.platform.is.safari && !this.$q.platform.is.ios) {

                window.addEventListener("orientationchange", () =>{
                    if (screen.orientation.type.includes('portrait')) {
                        this.$q.fullscreen.exit()
                    this.exitFullScreen()
                }
                else if (screen.orientation.type.includes('landscape')) {
                    this.$q.fullscreen.request()
                    this.enterFullScreen()
                }
            })
            }
        }

        document.addEventListener("fullscreenchange", (e) => {
            if(!document.fullscreenElement) {
                this.exitFullScreen()
            }
        });

        document.addEventListener("webkitfullscreenchange", (e) => {
            if(!document.fullscreenElement) {
                this.exitFullScreen()
            }
        });

        document.addEventListener("keydown", (e) => {
            switch (e.keyCode) {
                case 37: this.goLeft()
                break
                case 39: this.goRight()
                break
            }
        })
    },

    destroyed() {
        document.removeEventListener("keydown", () => {})
        document.removeEventListener("fullscreenchange", () => {})
        if (this.$q.platform.is.mobile && !this.$q.platform.is.safari) {
            document.removeEventListener("orientationchange", () => {})
        }
    }
}
</script>

<style lang="stylus" scoped>
.container
    width 100%
    height 80vh
    display flex
    flex-direction column
    justify-content center
    align-items center

.player
    width 49vw
    background-color black
    justify-content center

.slide
    width 100%
    height auto

.controller
    display flex
    width 49vw
    padding 10px 0px
    justify-content center
    align-items center
    height 40px
    position relative

.arrowleft
    position absolute
    height 100vh
    width 40%
    display none
    cursor w-resize

.arrowright
    position absolute
    right 0
    top 0
    height 100vh
    width 40%
    display none
    cursor e-resize

.fullscreen
    position absolute
    right 0
    width 30px
    margin-right 20px
    min-height 0

@media (max-width: 600px)
    .player
        width 100vw

    .controller
        width: 100vw
</style>
